module.exports = __webpack_public_path__ + "img/file-img-docx.b7f31a17.jpg";